export default {
    currentUnit: {},
    classList: [],
    classSchedulesList: [],
    schedulesList: []
}